import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
// fallow-ignore-next-line circular-dependency -- co-located route modules must import their parent route from routes.tsx, which imports this module back into the tree; the same cycle already exists for every migrated route (see the workflow Memories and runs tabs).
import { agentDefinitionLayoutRoute } from 'src/routes';

// The agent Versions tab (AI-458): a child of the (still centrally declared)
// `/agents/$agentDefinitionId` layout, so its real URL is
// `/agents/$agentDefinitionId/versions`.
//
// TRANSITIONAL LOCATION — same constraint the workflow Memories tab documents:
// `custom/tanstack-route-file-path` cannot express a child of an unmigrated
// central layout, because with code-based `createRoute` the declared path must
// be parent-relative (`/versions`) while the rule resolves a module's full path
// from its own declaration (an imported parent stops the walk). So the file has
// to live where `/versions` alone derives. When the `/agents/$agentDefinitionId`
// layout migrates to
// `src/pages/authenticated/agents/$agentDefinitionId/route.tsx`, move this
// module to `.../$agentDefinitionId/versions/index.tsx`.
export const Route = createRoute({
  getParentRoute: () => agentDefinitionLayoutRoute,
  path: '/versions',
  component: lazyRouteComponent(
    () => import('../../agents/AgentDefinitionVersionsTab'),
    'AgentDefinitionVersionsTab',
  ),
  loader: () => ({ crumb: msg('Versions', { context: 'page breadcrumb' }) }),
});
